import jquery from 'jquery'
import "@rails/request.js"
import * as bootstrap from 'bootstrap'
import { createApp } from 'vue/dist/vue.esm-bundler';
import { createI18n } from 'vue-i18n'
import Rails from '@rails/ujs';
import ActionCableVue from "actioncable-vue";

import Fullscreen from '../components/fullscreen.vue'
import TimetableShift from '../components/timetable-shift.vue'
import TimetableRequirement from '../components/timetable-requirement.vue'
import TimetablePositions from '../components/timetable-positions.vue'
import TimetableVolunteers from '../components/timetable-volunteers.vue'
import KanbanDevisions from '../components/kanban-divisions.vue'
import VolunteerSubscription from '../components/volunteer-subscription.vue'
import autosize from 'autosize'

window.jQuery = jquery
window.$ = jquery
window.bootstrap = bootstrap


// Extend bootstrap's tooltip sanitizer to correctly display tags
// See: https://getbootstrap.com/docs/5.2/getting-started/javascript/#sanitizer
var tooltipSanitizerWhitelist = bootstrap.Tooltip.Default.allowList
tooltipSanitizerWhitelist.a.push('data-remote', 'data-method')

const connectionUrl = document.querySelector('meta[name="action-cable-url"]')?.getAttribute('content');
const app = createApp().use(ActionCableVue, { connectionUrl: connectionUrl })

/* vue-i18n (https://github.com/intlify/vue-i18n-next) */
const messages = {
  en: {
    divisions: {
      attributes: {
        allrounders: 'Allrounders'
      }
    },
    subscription: {
      subscribed: 'Subscribed',
      unsubscribed: 'Unsubscribed',
      unsupported: 'Subscriptions not supported by your browser',
    },
    timetable: {
      buttons: {
        toggle_slot_duration: 'Toggle slot duration'
      },
      positions: {
        buttons: {
          edit_shifts: {
            label: 'Edit shifts',
            text: 'Shifts',
          },
          edit_requirements: {
            label: 'Edit requirements',
            text: 'Requirements'
          },
        },
        headers: {
          position: 'Name'
        }
      },
      shifts: {
        delete: "Delete",
        duplicate: "Duplicate",
        edit: "Edit",
        no_show: "No show",
        position_filled: "Position filled",
        position_unfilled: "Position unfilled",
        show: "Showed up",
        swap: "Swap",
        conflicts: {
          no_show: "No show",
          parallel_shift: "Parallel shift",
          no_attendance: "No attendance",
          not_present: "Not present",
          exceeding_working_time_limit: "Exceeding working time limit",
          no_break: "Break time too short",
        }
      },
      volunteers: {
        absent: "absent",
        present: "present",
        buttons: {
          add_attendance: {
            label: 'Add attendance',
            text: 'Attendance',
          },
          edit_shifts: {
            label: 'Edit shifts',
            text: 'Shifts',
          },
          remove_attendance: {
            label: 'Remove attendance',
            text: 'Attendance',
          },
        },
        headers: {
          volunteer: 'Name'
        }
      }
    }
  },
  de: {
    divisions: {
      attributes: {
        allrounders: 'Springer'
      }
    },
    subscription: {
      subscribed: 'Benachrichtigungen aktiv',
      unsubscribed: 'Benachrichtigungen deaktiviert',
      unsupported: 'Benachrichtigungen werden von diesem Browser nicht unterstützt',
    },
    timetable: {
      buttons: {
        toggle_slot_duration: 'Slotgröße verändern'
      },
      positions: {
        buttons: {
          edit_shifts: {
            label: 'Schichten editieren',
            text: 'Schichten',
          },
          edit_requirements: {
            label: 'Anforderungen editieren',
            text: 'Anforderungen',
          },
        },
        headers: {
          position: 'Name'
        }
      },
      shifts: {
        delete: "Löschen",
        duplicate: "Duplizieren",
        edit: "Editieren",
        no_show: "Nicht aufgetaucht",
        position_filled: "Position besetzt",
        position_unfilled: "Position nicht besetzt",
        show: "Aufgetaucht",
        swap: "Tauschen",
        conflicts: {
          no_show: "Nicht aufgetaucht",
          parallel_shift: "Parallele Schicht",
          no_attendance: "Keine Anwesenheit",
          not_present: "Nicht anwesend",
          exceeding_working_time_limit: "Arbeitszeitbegrenzung überschritten",
          no_break: "Pausenzeit zu kurz",
        }
      },
      volunteers: {
        absent: "abwesend",
        present: "anwesend",
        buttons: {
          add_attendance: {
            label: 'Anwesenheit hinzufügen',
            text: 'Anwesenheit',
          },
          edit_shifts: {
            label: 'Schichten editieren',
            text: 'Schichten',
          },
          remove_attendance: {
            label: 'Anwesenheit entfernen',
            text: 'Anwesenheit',
          },
        },
        headers: {
          volunteer: 'Name'
        }
      }
    }
  }
}
const i18n = createI18n({
  locale: document.documentElement.lang,
  fallbackLocale: 'en',
  messages,
})
app.use(i18n)

app.component('VueFullscreen', Fullscreen)
app.component('VueTimetableShift', TimetableShift)
app.component('VueTimetableRequirement', TimetableRequirement)
app.component('VueTimetablePositions', TimetablePositions)
app.component('VueTimetableVolunteers', TimetableVolunteers)
app.component('VueKanbanDivisions', KanbanDevisions)
app.component('VueVolunteerSubscription', VolunteerSubscription)
app.mount('#app');

Rails.start();

autosize($('textarea'));

const registerServiceWorker = async () => {
  if (navigator.serviceWorker) {
    try {
      await navigator.serviceWorker.register('/service-worker.js');
      console.log('Service worker registered!');
      return true;
    } catch (error) {
      console.error('Error registering service worker: ', error);
    }
  }
  return false;
};